// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the @augloop/code-gen tool.
// Source: https://dev.azure.com/office/ISS/_git/augloop-server?path=%2Fmodules%2Ftypes-core%2Fsrc%2Foperations.ts
// Changes to this file may cause incorrect behavior and will be lost upon regeneration.
// </auto-generated>
// ------------------------------------------------------------------------------
import { EntryPoint, ItemChanges, ItemOperation, OperationErrorCode } from '../../operations';
import { AddOperation, CancelSignalTriggeredWorkflowExecutionOperation, DeleteOperation, DeltaUpdateOperation, FocusOperation, ItemChangesDelta, ItemDelta, MicroSyncOperation, MoveOperation, Operation, OperationWithSiblingContext, PurgeByTypesOperation, PurgeOperation, PurgeSubtreeExceptTypesOperation, SignalOperation, UpdateAnnotationMetaDataOperation, UpdateOperation, VisibilityOperation } from '../operations.g';
import { scenarioValidatorInstance } from '../../generated/validator/scenarios-validator.g';
import { schemaObjectHeaderValidatorInstance, schemaObjectValidatorInstance } from '../../generated/validator/schema-object-validator.g';
import { annotationMetaDataValidatorInstance } from '../../generated/validator/annotations-validator.g';
import { validateArray } from '@augloop/validator-common';
export class SourceInfoValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'SourceInfo: Expected object, got undefined object for SourceInfoValidator' };
        }
        if ((obj.featureId !== undefined)) {
            const result = scenarioValidatorInstance.validate(obj.featureId);
            if (!result.success) {
                result.error = "SourceInfo.featureId: " + result.error;
                return result;
            }
        }
        if ((obj.entryPoint !== undefined)) {
            const result = entryPointValidatorInstance.validate(obj.entryPoint);
            if (!result.success) {
                result.error = "SourceInfo.entryPoint: " + result.error;
                return result;
            }
        }
        return { success: true };
    }
}
export const sourceInfoValidatorInstance = new SourceInfoValidator();
export class ItemValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'Item: Expected object, got undefined object for ItemValidator' };
        }
        if (obj.id === undefined) {
            return { success: false, error: 'Item: Required field "id" is missing' };
        }
        else if (typeof obj.id !== 'string') {
            return { success: false, error: 'Item: Required field "id" is wrong type' };
        }
        if ((obj.source !== undefined) && (typeof obj.source !== 'string')) {
            return { success: false, error: 'Item: Optional field "source" is wrong type' };
        }
        if ((obj.sourceTimestamp !== undefined) && (typeof obj.sourceTimestamp !== 'number')) {
            return { success: false, error: 'Item: Optional field "sourceTimestamp" is wrong type' };
        }
        if ((obj.revId !== undefined) && (typeof obj.revId !== 'string')) {
            return { success: false, error: 'Item: Optional field "revId" is wrong type' };
        }
        if ((obj.contextId !== undefined) && (typeof obj.contextId !== 'string')) {
            return { success: false, error: 'Item: Optional field "contextId" is wrong type' };
        }
        if ((obj.body !== undefined)) {
            const result = schemaObjectValidatorInstance.validate(obj.body);
            if (!result.success) {
                result.error = "Item.body: " + result.error;
                return result;
            }
        }
        if ((obj.sourceInfo !== undefined)) {
            const result = sourceInfoValidatorInstance.validate(obj.sourceInfo);
            if (!result.success) {
                result.error = "Item.sourceInfo: " + result.error;
                return result;
            }
        }
        return { success: true };
    }
}
export const itemValidatorInstance = new ItemValidator();
export class ItemReferenceValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'ItemReference: Expected object, got undefined object for ItemReferenceValidator' };
        }
        if (obj.referencedPath === undefined) {
            return { success: false, error: 'ItemReference: Required field "referencedPath" is missing' };
        }
        else {
            const result = validateArray(obj.referencedPath, 1, undefined, 'string');
            if (!result.success) {
                result.error = "ItemReference.referencedPath: " + result.error;
                return result;
            }
        }
        return { success: true };
    }
}
export const itemReferenceValidatorInstance = new ItemReferenceValidator();
export class ItemDeltaValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'ItemDelta: Expected object, got undefined object for ItemDeltaValidator' };
        }
        if ((obj.state !== undefined) && (typeof obj.state !== 'string')) {
            return { success: false, error: 'ItemDelta: Optional field "state" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!ItemDelta.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "ItemDelta"' };
        }
        return { success: true };
    }
}
export const itemDeltaValidatorInstance = new ItemDeltaValidator();
export class ItemChangesDeltaValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'ItemChangesDelta: Expected object, got undefined object for ItemChangesDeltaValidator' };
        }
        if (obj.changes === undefined) {
            return { success: false, error: 'ItemChangesDelta: Required field "changes" is missing' };
        }
        else {
            const result = validateArray(obj.changes, 1, itemChangesValidatorInstance, '{ItemChanges}');
            if (!result.success) {
                result.error = "ItemChangesDelta.changes: " + result.error;
                return result;
            }
        }
        if ((obj.state !== undefined) && (typeof obj.state !== 'string')) {
            return { success: false, error: 'ItemChangesDelta: Optional field "state" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!ItemChangesDelta.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "ItemChangesDelta"' };
        }
        return { success: true };
    }
}
export const itemChangesDeltaValidatorInstance = new ItemChangesDeltaValidator();
export class ItemWithPathValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'ItemWithPath: Expected object, got undefined object for ItemWithPathValidator' };
        }
        if (obj.parentPath === undefined) {
            return { success: false, error: 'ItemWithPath: Required field "parentPath" is missing' };
        }
        else {
            const result = validateArray(obj.parentPath, 1, undefined, 'string');
            if (!result.success) {
                result.error = "ItemWithPath.parentPath: " + result.error;
                return result;
            }
        }
        if ((obj.delta !== undefined)) {
            const result = itemDeltaValidatorInstance.validate(obj.delta);
            if (!result.success) {
                result.error = "ItemWithPath.delta: " + result.error;
                return result;
            }
        }
        if (obj.deltas !== undefined) {
            const result = validateArray(obj.deltas, 1, itemDeltaValidatorInstance, '{ItemDelta}');
            if (!result.success) {
                result.error = "ItemWithPath.deltas: " + result.error;
                return result;
            }
        }
        if ((obj.op !== undefined)) {
            const result = itemOperationValidatorInstance.validate(obj.op);
            if (!result.success) {
                result.error = "ItemWithPath.op: " + result.error;
                return result;
            }
        }
        if (obj.id === undefined) {
            return { success: false, error: 'ItemWithPath: Required field "id" is missing' };
        }
        else if (typeof obj.id !== 'string') {
            return { success: false, error: 'ItemWithPath: Required field "id" is wrong type' };
        }
        if ((obj.source !== undefined) && (typeof obj.source !== 'string')) {
            return { success: false, error: 'ItemWithPath: Optional field "source" is wrong type' };
        }
        if ((obj.sourceTimestamp !== undefined) && (typeof obj.sourceTimestamp !== 'number')) {
            return { success: false, error: 'ItemWithPath: Optional field "sourceTimestamp" is wrong type' };
        }
        if ((obj.revId !== undefined) && (typeof obj.revId !== 'string')) {
            return { success: false, error: 'ItemWithPath: Optional field "revId" is wrong type' };
        }
        if ((obj.contextId !== undefined) && (typeof obj.contextId !== 'string')) {
            return { success: false, error: 'ItemWithPath: Optional field "contextId" is wrong type' };
        }
        if ((obj.body !== undefined)) {
            const result = schemaObjectValidatorInstance.validate(obj.body);
            if (!result.success) {
                result.error = "ItemWithPath.body: " + result.error;
                return result;
            }
        }
        if ((obj.sourceInfo !== undefined)) {
            const result = sourceInfoValidatorInstance.validate(obj.sourceInfo);
            if (!result.success) {
                result.error = "ItemWithPath.sourceInfo: " + result.error;
                return result;
            }
        }
        return { success: true };
    }
}
export const itemWithPathValidatorInstance = new ItemWithPathValidator();
export class OperationValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'Operation: Expected object, got undefined object for OperationValidator' };
        }
        if (obj.parentPath === undefined) {
            return { success: false, error: 'Operation: Required field "parentPath" is missing' };
        }
        else {
            const result = validateArray(obj.parentPath, 1, undefined, 'string');
            if (!result.success) {
                result.error = "Operation.parentPath: " + result.error;
                return result;
            }
        }
        if ((obj.parentRevId !== undefined) && (typeof obj.parentRevId !== 'string')) {
            return { success: false, error: 'Operation: Optional field "parentRevId" is wrong type' };
        }
        if (obj.items === undefined) {
            return { success: false, error: 'Operation: Required field "items" is missing' };
        }
        else {
            const result = validateArray(obj.items, 1, itemValidatorInstance, '{Item}');
            if (!result.success) {
                result.error = "Operation.items: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!Operation.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "Operation"' };
        }
        return { success: true };
    }
}
export const operationValidatorInstance = new OperationValidator();
export class OperationErrorValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'OperationError: Expected object, got undefined object for OperationErrorValidator' };
        }
        if (obj.path === undefined) {
            return { success: false, error: 'OperationError: Required field "path" is missing' };
        }
        else {
            const result = validateArray(obj.path, 1, undefined, 'string');
            if (!result.success) {
                result.error = "OperationError.path: " + result.error;
                return result;
            }
        }
        if ((obj.errorCode !== undefined)) {
            const result = operationErrorCodeValidatorInstance.validate(obj.errorCode);
            if (!result.success) {
                result.error = "OperationError.errorCode: " + result.error;
                return result;
            }
        }
        return { success: true };
    }
}
export const operationErrorValidatorInstance = new OperationErrorValidator();
export class OperationWithSiblingContextValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'OperationWithSiblingContext: Expected object, got undefined object for OperationWithSiblingContextValidator' };
        }
        if ((obj.prevId !== undefined) && (typeof obj.prevId !== 'string')) {
            return { success: false, error: 'OperationWithSiblingContext: Optional field "prevId" is wrong type' };
        }
        if ((obj.nextId !== undefined) && (typeof obj.nextId !== 'string')) {
            return { success: false, error: 'OperationWithSiblingContext: Optional field "nextId" is wrong type' };
        }
        if (obj.parentPath === undefined) {
            return { success: false, error: 'OperationWithSiblingContext: Required field "parentPath" is missing' };
        }
        else {
            const result = validateArray(obj.parentPath, 1, undefined, 'string');
            if (!result.success) {
                result.error = "OperationWithSiblingContext.parentPath: " + result.error;
                return result;
            }
        }
        if ((obj.parentRevId !== undefined) && (typeof obj.parentRevId !== 'string')) {
            return { success: false, error: 'OperationWithSiblingContext: Optional field "parentRevId" is wrong type' };
        }
        if (obj.items === undefined) {
            return { success: false, error: 'OperationWithSiblingContext: Required field "items" is missing' };
        }
        else {
            const result = validateArray(obj.items, 1, itemValidatorInstance, '{Item}');
            if (!result.success) {
                result.error = "OperationWithSiblingContext.items: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!OperationWithSiblingContext.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "OperationWithSiblingContext"' };
        }
        return { success: true };
    }
}
export const operationWithSiblingContextValidatorInstance = new OperationWithSiblingContextValidator();
export class AddOperationValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'AddOperation: Expected object, got undefined object for AddOperationValidator' };
        }
        if ((obj.isTriggeredBySyncDelta !== undefined) && (typeof obj.isTriggeredBySyncDelta !== 'boolean')) {
            return { success: false, error: 'AddOperation: Optional field "isTriggeredBySyncDelta" is wrong type' };
        }
        if ((obj.prevId !== undefined) && (typeof obj.prevId !== 'string')) {
            return { success: false, error: 'AddOperation: Optional field "prevId" is wrong type' };
        }
        if ((obj.nextId !== undefined) && (typeof obj.nextId !== 'string')) {
            return { success: false, error: 'AddOperation: Optional field "nextId" is wrong type' };
        }
        if (obj.parentPath === undefined) {
            return { success: false, error: 'AddOperation: Required field "parentPath" is missing' };
        }
        else {
            const result = validateArray(obj.parentPath, 1, undefined, 'string');
            if (!result.success) {
                result.error = "AddOperation.parentPath: " + result.error;
                return result;
            }
        }
        if ((obj.parentRevId !== undefined) && (typeof obj.parentRevId !== 'string')) {
            return { success: false, error: 'AddOperation: Optional field "parentRevId" is wrong type' };
        }
        if (obj.items === undefined) {
            return { success: false, error: 'AddOperation: Required field "items" is missing' };
        }
        else {
            const result = validateArray(obj.items, 1, itemValidatorInstance, '{Item}');
            if (!result.success) {
                result.error = "AddOperation.items: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!AddOperation.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "AddOperation"' };
        }
        return { success: true };
    }
}
export const addOperationValidatorInstance = new AddOperationValidator();
export class MoveOperationValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'MoveOperation: Expected object, got undefined object for MoveOperationValidator' };
        }
        if (obj.prevParentPath === undefined) {
            return { success: false, error: 'MoveOperation: Required field "prevParentPath" is missing' };
        }
        else {
            const result = validateArray(obj.prevParentPath, 1, undefined, 'string');
            if (!result.success) {
                result.error = "MoveOperation.prevParentPath: " + result.error;
                return result;
            }
        }
        if ((obj.prevId !== undefined) && (typeof obj.prevId !== 'string')) {
            return { success: false, error: 'MoveOperation: Optional field "prevId" is wrong type' };
        }
        if ((obj.nextId !== undefined) && (typeof obj.nextId !== 'string')) {
            return { success: false, error: 'MoveOperation: Optional field "nextId" is wrong type' };
        }
        if (obj.parentPath === undefined) {
            return { success: false, error: 'MoveOperation: Required field "parentPath" is missing' };
        }
        else {
            const result = validateArray(obj.parentPath, 1, undefined, 'string');
            if (!result.success) {
                result.error = "MoveOperation.parentPath: " + result.error;
                return result;
            }
        }
        if ((obj.parentRevId !== undefined) && (typeof obj.parentRevId !== 'string')) {
            return { success: false, error: 'MoveOperation: Optional field "parentRevId" is wrong type' };
        }
        if (obj.items === undefined) {
            return { success: false, error: 'MoveOperation: Required field "items" is missing' };
        }
        else {
            const result = validateArray(obj.items, 1, itemValidatorInstance, '{Item}');
            if (!result.success) {
                result.error = "MoveOperation.items: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!MoveOperation.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "MoveOperation"' };
        }
        return { success: true };
    }
}
export const moveOperationValidatorInstance = new MoveOperationValidator();
export class UpdateAnnotationMetaDataOperationValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'UpdateAnnotationMetaDataOperation: Expected object, got undefined object for UpdateAnnotationMetaDataOperationValidator' };
        }
        if (obj.M_ === undefined) {
            return { success: false, error: 'UpdateAnnotationMetaDataOperation: Required field "M_" is missing' };
        }
        else {
            const result = annotationMetaDataValidatorInstance.validate(obj.M_);
            if (!result.success) {
                result.error = "UpdateAnnotationMetaDataOperation.M_: " + result.error;
                return result;
            }
        }
        if (obj.parentPath === undefined) {
            return { success: false, error: 'UpdateAnnotationMetaDataOperation: Required field "parentPath" is missing' };
        }
        else {
            const result = validateArray(obj.parentPath, 1, undefined, 'string');
            if (!result.success) {
                result.error = "UpdateAnnotationMetaDataOperation.parentPath: " + result.error;
                return result;
            }
        }
        if ((obj.parentRevId !== undefined) && (typeof obj.parentRevId !== 'string')) {
            return { success: false, error: 'UpdateAnnotationMetaDataOperation: Optional field "parentRevId" is wrong type' };
        }
        if (obj.items === undefined) {
            return { success: false, error: 'UpdateAnnotationMetaDataOperation: Required field "items" is missing' };
        }
        else {
            const result = validateArray(obj.items, 1, itemValidatorInstance, '{Item}');
            if (!result.success) {
                result.error = "UpdateAnnotationMetaDataOperation.items: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!UpdateAnnotationMetaDataOperation.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "UpdateAnnotationMetaDataOperation"' };
        }
        return { success: true };
    }
}
export const updateAnnotationMetaDataOperationValidatorInstance = new UpdateAnnotationMetaDataOperationValidator();
export class UpdateOperationValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'UpdateOperation: Expected object, got undefined object for UpdateOperationValidator' };
        }
        if ((obj.isTriggeredBySyncDelta !== undefined) && (typeof obj.isTriggeredBySyncDelta !== 'boolean')) {
            return { success: false, error: 'UpdateOperation: Optional field "isTriggeredBySyncDelta" is wrong type' };
        }
        if (obj.parentPath === undefined) {
            return { success: false, error: 'UpdateOperation: Required field "parentPath" is missing' };
        }
        else {
            const result = validateArray(obj.parentPath, 1, undefined, 'string');
            if (!result.success) {
                result.error = "UpdateOperation.parentPath: " + result.error;
                return result;
            }
        }
        if ((obj.parentRevId !== undefined) && (typeof obj.parentRevId !== 'string')) {
            return { success: false, error: 'UpdateOperation: Optional field "parentRevId" is wrong type' };
        }
        if (obj.items === undefined) {
            return { success: false, error: 'UpdateOperation: Required field "items" is missing' };
        }
        else {
            const result = validateArray(obj.items, 1, itemValidatorInstance, '{Item}');
            if (!result.success) {
                result.error = "UpdateOperation.items: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!UpdateOperation.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "UpdateOperation"' };
        }
        return { success: true };
    }
}
export const updateOperationValidatorInstance = new UpdateOperationValidator();
export class DeleteOperationValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'DeleteOperation: Expected object, got undefined object for DeleteOperationValidator' };
        }
        if ((obj.isTriggeredBySyncDelta !== undefined) && (typeof obj.isTriggeredBySyncDelta !== 'boolean')) {
            return { success: false, error: 'DeleteOperation: Optional field "isTriggeredBySyncDelta" is wrong type' };
        }
        if (obj.parentPath === undefined) {
            return { success: false, error: 'DeleteOperation: Required field "parentPath" is missing' };
        }
        else {
            const result = validateArray(obj.parentPath, 1, undefined, 'string');
            if (!result.success) {
                result.error = "DeleteOperation.parentPath: " + result.error;
                return result;
            }
        }
        if ((obj.parentRevId !== undefined) && (typeof obj.parentRevId !== 'string')) {
            return { success: false, error: 'DeleteOperation: Optional field "parentRevId" is wrong type' };
        }
        if (obj.items === undefined) {
            return { success: false, error: 'DeleteOperation: Required field "items" is missing' };
        }
        else {
            const result = validateArray(obj.items, 1, itemValidatorInstance, '{Item}');
            if (!result.success) {
                result.error = "DeleteOperation.items: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!DeleteOperation.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "DeleteOperation"' };
        }
        return { success: true };
    }
}
export const deleteOperationValidatorInstance = new DeleteOperationValidator();
export class PurgeOperationValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'PurgeOperation: Expected object, got undefined object for PurgeOperationValidator' };
        }
        if (obj.parentPath === undefined) {
            return { success: false, error: 'PurgeOperation: Required field "parentPath" is missing' };
        }
        else {
            const result = validateArray(obj.parentPath, 1, undefined, 'string');
            if (!result.success) {
                result.error = "PurgeOperation.parentPath: " + result.error;
                return result;
            }
        }
        if ((obj.parentRevId !== undefined) && (typeof obj.parentRevId !== 'string')) {
            return { success: false, error: 'PurgeOperation: Optional field "parentRevId" is wrong type' };
        }
        if (obj.items === undefined) {
            return { success: false, error: 'PurgeOperation: Required field "items" is missing' };
        }
        else {
            const result = validateArray(obj.items, 1, itemValidatorInstance, '{Item}');
            if (!result.success) {
                result.error = "PurgeOperation.items: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!PurgeOperation.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "PurgeOperation"' };
        }
        return { success: true };
    }
}
export const purgeOperationValidatorInstance = new PurgeOperationValidator();
export class PurgeSubtreeExceptTypesOperationValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'PurgeSubtreeExceptTypesOperation: Expected object, got undefined object for PurgeSubtreeExceptTypesOperationValidator' };
        }
        if (obj.typesToKeep === undefined) {
            return { success: false, error: 'PurgeSubtreeExceptTypesOperation: Required field "typesToKeep" is missing' };
        }
        else {
            const result = validateArray(obj.typesToKeep, 1, undefined, 'string');
            if (!result.success) {
                result.error = "PurgeSubtreeExceptTypesOperation.typesToKeep: " + result.error;
                return result;
            }
        }
        if (obj.parentPath === undefined) {
            return { success: false, error: 'PurgeSubtreeExceptTypesOperation: Required field "parentPath" is missing' };
        }
        else {
            const result = validateArray(obj.parentPath, 1, undefined, 'string');
            if (!result.success) {
                result.error = "PurgeSubtreeExceptTypesOperation.parentPath: " + result.error;
                return result;
            }
        }
        if ((obj.parentRevId !== undefined) && (typeof obj.parentRevId !== 'string')) {
            return { success: false, error: 'PurgeSubtreeExceptTypesOperation: Optional field "parentRevId" is wrong type' };
        }
        if (obj.items === undefined) {
            return { success: false, error: 'PurgeSubtreeExceptTypesOperation: Required field "items" is missing' };
        }
        else {
            const result = validateArray(obj.items, 1, itemValidatorInstance, '{Item}');
            if (!result.success) {
                result.error = "PurgeSubtreeExceptTypesOperation.items: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!PurgeSubtreeExceptTypesOperation.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "PurgeSubtreeExceptTypesOperation"' };
        }
        return { success: true };
    }
}
export const purgeSubtreeExceptTypesOperationValidatorInstance = new PurgeSubtreeExceptTypesOperationValidator();
export class PurgeByTypesOperationValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'PurgeByTypesOperation: Expected object, got undefined object for PurgeByTypesOperationValidator' };
        }
        if (obj.types === undefined) {
            return { success: false, error: 'PurgeByTypesOperation: Required field "types" is missing' };
        }
        else {
            const result = validateArray(obj.types, 1, undefined, 'string');
            if (!result.success) {
                result.error = "PurgeByTypesOperation.types: " + result.error;
                return result;
            }
        }
        if (obj.parentPath === undefined) {
            return { success: false, error: 'PurgeByTypesOperation: Required field "parentPath" is missing' };
        }
        else {
            const result = validateArray(obj.parentPath, 1, undefined, 'string');
            if (!result.success) {
                result.error = "PurgeByTypesOperation.parentPath: " + result.error;
                return result;
            }
        }
        if ((obj.parentRevId !== undefined) && (typeof obj.parentRevId !== 'string')) {
            return { success: false, error: 'PurgeByTypesOperation: Optional field "parentRevId" is wrong type' };
        }
        if (obj.items === undefined) {
            return { success: false, error: 'PurgeByTypesOperation: Required field "items" is missing' };
        }
        else {
            const result = validateArray(obj.items, 1, itemValidatorInstance, '{Item}');
            if (!result.success) {
                result.error = "PurgeByTypesOperation.items: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!PurgeByTypesOperation.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "PurgeByTypesOperation"' };
        }
        return { success: true };
    }
}
export const purgeByTypesOperationValidatorInstance = new PurgeByTypesOperationValidator();
export class FocusOperationValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'FocusOperation: Expected object, got undefined object for FocusOperationValidator' };
        }
        if (obj.isFocused === undefined) {
            return { success: false, error: 'FocusOperation: Required field "isFocused" is missing' };
        }
        else if (typeof obj.isFocused !== 'boolean') {
            return { success: false, error: 'FocusOperation: Required field "isFocused" is wrong type' };
        }
        if (obj.parentPath === undefined) {
            return { success: false, error: 'FocusOperation: Required field "parentPath" is missing' };
        }
        else {
            const result = validateArray(obj.parentPath, 1, undefined, 'string');
            if (!result.success) {
                result.error = "FocusOperation.parentPath: " + result.error;
                return result;
            }
        }
        if ((obj.parentRevId !== undefined) && (typeof obj.parentRevId !== 'string')) {
            return { success: false, error: 'FocusOperation: Optional field "parentRevId" is wrong type' };
        }
        if (obj.items === undefined) {
            return { success: false, error: 'FocusOperation: Required field "items" is missing' };
        }
        else {
            const result = validateArray(obj.items, 1, itemValidatorInstance, '{Item}');
            if (!result.success) {
                result.error = "FocusOperation.items: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!FocusOperation.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "FocusOperation"' };
        }
        return { success: true };
    }
}
export const focusOperationValidatorInstance = new FocusOperationValidator();
export class VisibilityOperationValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'VisibilityOperation: Expected object, got undefined object for VisibilityOperationValidator' };
        }
        if (obj.isVisible === undefined) {
            return { success: false, error: 'VisibilityOperation: Required field "isVisible" is missing' };
        }
        else if (typeof obj.isVisible !== 'boolean') {
            return { success: false, error: 'VisibilityOperation: Required field "isVisible" is wrong type' };
        }
        if (obj.parentPath === undefined) {
            return { success: false, error: 'VisibilityOperation: Required field "parentPath" is missing' };
        }
        else {
            const result = validateArray(obj.parentPath, 1, undefined, 'string');
            if (!result.success) {
                result.error = "VisibilityOperation.parentPath: " + result.error;
                return result;
            }
        }
        if ((obj.parentRevId !== undefined) && (typeof obj.parentRevId !== 'string')) {
            return { success: false, error: 'VisibilityOperation: Optional field "parentRevId" is wrong type' };
        }
        if (obj.items === undefined) {
            return { success: false, error: 'VisibilityOperation: Required field "items" is missing' };
        }
        else {
            const result = validateArray(obj.items, 1, itemValidatorInstance, '{Item}');
            if (!result.success) {
                result.error = "VisibilityOperation.items: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!VisibilityOperation.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "VisibilityOperation"' };
        }
        return { success: true };
    }
}
export const visibilityOperationValidatorInstance = new VisibilityOperationValidator();
export class DeltaUpdateOperationValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'DeltaUpdateOperation: Expected object, got undefined object for DeltaUpdateOperationValidator' };
        }
        if (obj.parentPath === undefined) {
            return { success: false, error: 'DeltaUpdateOperation: Required field "parentPath" is missing' };
        }
        else {
            const result = validateArray(obj.parentPath, 1, undefined, 'string');
            if (!result.success) {
                result.error = "DeltaUpdateOperation.parentPath: " + result.error;
                return result;
            }
        }
        if ((obj.parentRevId !== undefined) && (typeof obj.parentRevId !== 'string')) {
            return { success: false, error: 'DeltaUpdateOperation: Optional field "parentRevId" is wrong type' };
        }
        if (obj.items === undefined) {
            return { success: false, error: 'DeltaUpdateOperation: Required field "items" is missing' };
        }
        else {
            const result = validateArray(obj.items, 1, itemValidatorInstance, '{Item}');
            if (!result.success) {
                result.error = "DeltaUpdateOperation.items: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!DeltaUpdateOperation.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "DeltaUpdateOperation"' };
        }
        return { success: true };
    }
}
export const deltaUpdateOperationValidatorInstance = new DeltaUpdateOperationValidator();
export class MicroSyncOperationValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'MicroSyncOperation: Expected object, got undefined object for MicroSyncOperationValidator' };
        }
        if ((obj.seq !== undefined) && (typeof obj.seq !== 'number')) {
            return { success: false, error: 'MicroSyncOperation: Optional field "seq" is wrong type' };
        }
        if ((obj.opType !== undefined) && (typeof obj.opType !== 'string')) {
            return { success: false, error: 'MicroSyncOperation: Optional field "opType" is wrong type' };
        }
        if (obj.parentPath === undefined) {
            return { success: false, error: 'MicroSyncOperation: Required field "parentPath" is missing' };
        }
        else {
            const result = validateArray(obj.parentPath, 1, undefined, 'string');
            if (!result.success) {
                result.error = "MicroSyncOperation.parentPath: " + result.error;
                return result;
            }
        }
        if ((obj.parentRevId !== undefined) && (typeof obj.parentRevId !== 'string')) {
            return { success: false, error: 'MicroSyncOperation: Optional field "parentRevId" is wrong type' };
        }
        if (obj.items === undefined) {
            return { success: false, error: 'MicroSyncOperation: Required field "items" is missing' };
        }
        else {
            const result = validateArray(obj.items, 1, itemValidatorInstance, '{Item}');
            if (!result.success) {
                result.error = "MicroSyncOperation.items: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!MicroSyncOperation.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "MicroSyncOperation"' };
        }
        return { success: true };
    }
}
export const microSyncOperationValidatorInstance = new MicroSyncOperationValidator();
export class SignalOperationValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'SignalOperation: Expected object, got undefined object for SignalOperationValidator' };
        }
        if (obj.parentPath === undefined) {
            return { success: false, error: 'SignalOperation: Required field "parentPath" is missing' };
        }
        else {
            const result = validateArray(obj.parentPath, 1, undefined, 'string');
            if (!result.success) {
                result.error = "SignalOperation.parentPath: " + result.error;
                return result;
            }
        }
        if ((obj.parentRevId !== undefined) && (typeof obj.parentRevId !== 'string')) {
            return { success: false, error: 'SignalOperation: Optional field "parentRevId" is wrong type' };
        }
        if (obj.items === undefined) {
            return { success: false, error: 'SignalOperation: Required field "items" is missing' };
        }
        else {
            const result = validateArray(obj.items, 1, itemValidatorInstance, '{Item}');
            if (!result.success) {
                result.error = "SignalOperation.items: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!SignalOperation.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "SignalOperation"' };
        }
        return { success: true };
    }
}
export const signalOperationValidatorInstance = new SignalOperationValidator();
export class CancelSignalTriggeredWorkflowExecutionOperationValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'CancelSignalTriggeredWorkflowExecutionOperation: Expected object, got undefined object for CancelSignalTriggeredWorkflowExecutionOperationValidator' };
        }
        if (obj.parentPath === undefined) {
            return { success: false, error: 'CancelSignalTriggeredWorkflowExecutionOperation: Required field "parentPath" is missing' };
        }
        else {
            const result = validateArray(obj.parentPath, 1, undefined, 'string');
            if (!result.success) {
                result.error = "CancelSignalTriggeredWorkflowExecutionOperation.parentPath: " + result.error;
                return result;
            }
        }
        if ((obj.parentRevId !== undefined) && (typeof obj.parentRevId !== 'string')) {
            return { success: false, error: 'CancelSignalTriggeredWorkflowExecutionOperation: Optional field "parentRevId" is wrong type' };
        }
        if (obj.items === undefined) {
            return { success: false, error: 'CancelSignalTriggeredWorkflowExecutionOperation: Required field "items" is missing' };
        }
        else {
            const result = validateArray(obj.items, 1, itemValidatorInstance, '{Item}');
            if (!result.success) {
                result.error = "CancelSignalTriggeredWorkflowExecutionOperation.items: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!CancelSignalTriggeredWorkflowExecutionOperation.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "CancelSignalTriggeredWorkflowExecutionOperation"' };
        }
        return { success: true };
    }
}
export const cancelSignalTriggeredWorkflowExecutionOperationValidatorInstance = new CancelSignalTriggeredWorkflowExecutionOperationValidator();
export class EntryPointValidator {
    validate(value) {
        if (!EntryPointValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "EntryPoint"' };
        }
        return { success: true };
    }
}
EntryPointValidator.validValues = new Set([EntryPoint.Unknown, EntryPoint.Canvas, EntryPoint.CopilotChat, EntryPoint.Test]);
export const entryPointValidatorInstance = new EntryPointValidator();
export class ItemOperationValidator {
    validate(value) {
        if (!ItemOperationValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "ItemOperation"' };
        }
        return { success: true };
    }
}
ItemOperationValidator.validValues = new Set([ItemOperation.None, ItemOperation.Added, ItemOperation.Updated, ItemOperation.Deleted]);
export const itemOperationValidatorInstance = new ItemOperationValidator();
export class ItemChangesValidator {
    validate(value) {
        if (!ItemChangesValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "ItemChanges"' };
        }
        return { success: true };
    }
}
ItemChangesValidator.validValues = new Set([ItemChanges.ContentChanged, ItemChanges.ContentWasEmpty, ItemChanges.FormattingChanged, ItemChanges.ContentWasInsideOfTheTable]);
export const itemChangesValidatorInstance = new ItemChangesValidator();
export class OperationErrorCodeValidator {
    validate(value) {
        if (!OperationErrorCodeValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "OperationErrorCode"' };
        }
        return { success: true };
    }
}
OperationErrorCodeValidator.validValues = new Set([OperationErrorCode.AddOfZeroElements, OperationErrorCode.AddOfItemsWithExtraOrMissingIds, OperationErrorCode.AddOfItemWithUndefinedId, OperationErrorCode.AddOfUndefinedItem, OperationErrorCode.AddOfItemsWithDuplicateIds, OperationErrorCode.SetHeadToNonExistingItem, OperationErrorCode.DeleteOfNonExistingItem, OperationErrorCode.UpdateOfNonExistentItem, OperationErrorCode.UpdateOfStubbedItem, OperationErrorCode.MoveOfNonExistentItem, OperationErrorCode.UpdateMetaDataOfNonAnnotationType, OperationErrorCode.SequentialyInvertedUpdate, OperationErrorCode.MoveToTheSamePath, OperationErrorCode.UnknownOperation, OperationErrorCode.DeltaOfNonExistingItem]);
export const operationErrorCodeValidatorInstance = new OperationErrorCodeValidator();
//# sourceMappingURL=operations-validator.g.js.map